import React from 'react';

import { TbCoinYen } from "react-icons/tb";
import { GrPlan } from "react-icons/gr";
// import { TiFlowMerge } from "react-icons/ti";
import { RiGalleryView2 } from "react-icons/ri";
import { IoPeople } from "react-icons/io5";
import { FaInstagram, FaEnvelope } from 'react-icons/fa'; // Instagramとメールアイコンをインポート

const Navigation = ({ isMenuOpen, setIsMenuOpen }) => {
  return (
    <>
      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center space-x-5 font-serif text-gray-700">
        <a href="#about-us" className="hover:text-pink-400">
          Concept
        </a>
        <a href="#plan" className="hover:text-pink-400">
          Plan
        </a>
        <a href="#reservation" className="hover:text-pink-400">
          Order
        </a>
        {/* <a href="#flow" className="hover:text-pink-400">
          Flow
        </a> */}
        <a href="#gallery" className="hover:text-pink-400">
          Gallery
        </a>
        <a
          href="https://www.instagram.com/_cerise.m_/?igsh=N2JleHFxYzNmZGVj"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-pink-400"
        >
          <FaInstagram className="text-2xl" />
        </a>
        <a
          href="mailto:cerise.wedding.14@gmail.com"
          className="hover:text-pink-400"
        >
          <FaEnvelope className="text-2xl" />
        </a>
      </nav>

      {/* Mobile Navigation */}
      <nav
        className={`fixed top-0 right-0 h-screen w-64 bg-white shadow-md transform transition-transform duration-300 z-40 md:hidden ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col items-start p-6 space-y-4">
          {/* Close Button */}
          <button
            onClick={() => setIsMenuOpen(false)}
            className="self-end text-gray-800"
            aria-label="Close menu"
          >
            <svg
              className="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          {/* Navigation Links */}
          <a
            href="#about-us"
            className="text-lg font-serif text-gray-800 hover:text-pink-400"
            onClick={() => setIsMenuOpen(false)}
          >
            <div className='flex text-center justify-normal'>
              <IoPeople className="text-2xl mr-2" />Concept
            </div>
          </a>
          <a
            href="#plan"
            className="text-lg font-serif text-gray-800 hover:text-pink-400"
            onClick={() => setIsMenuOpen(false)}
          >
            <div className='flex text-center justify-normal'>
              <TbCoinYen className="text-2xl mr-2" />Plan
            </div>
          </a>
          <a
            href="#reservation"
            className="text-lg font-serif text-gray-800 hover:text-pink-400"
            onClick={() => setIsMenuOpen(false)}
          >
            <div className='flex text-center justify-normal'>
              <GrPlan className="text-2xl mr-2" />Order
            </div>
          </a>
          {/* <a
            href="#flow"
            className="text-lg font-serif text-gray-800 hover:text-pink-400"
            onClick={() => setIsMenuOpen(false)}
          >
            <div className='flex text-center justify-normal'>
              <TiFlowMerge className="text-2xl mr-2" />Flow
            </div>
          </a> */}
          <a
            href="#gallery"
            className="text-lg font-serif text-gray-800 hover:text-pink-400"
            onClick={() => setIsMenuOpen(false)}
          >
            <div className='flex text-center justify-normal'>
              <RiGalleryView2 className="text-2xl mr-2" />Gallery
            </div>
          </a>
          <a
            href="https://www.instagram.com/_cerise.m_/?igsh=N2JleHFxYzNmZGVj"
            target="_blank"
            rel="noopener noreferrer"
            className="text-lg font-serif text-gray-800 hover:text-pink-400"
          >
            <div className='flex text-center justify-normal'>
              <FaInstagram className="text-2xl mr-2" />Instagram
            </div>
          </a>
          <a
            href="mailto:cerise.wedding.14@gmail.com"
            className="text-lg font-serif text-gray-800 hover:text-pink-400"
          >
          <div className='flex text-center justify-normal'>
            <FaEnvelope className="text-2xl mr-2" />Mail
          </div>
          </a>
        </div>
      </nav>
    </>
  );
};

export default Navigation;
